import { Helmet } from 'react-helmet-async';
import { useSiteInfo } from '../context/SiteContext';
import { useSearchParams, Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import NewsGrid from '../components/NewsGrid';

function formatCategorySlug(slug: string): string {
  return slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export default function News() {
  const { siteInfo } = useSiteInfo();
  const [searchParams] = useSearchParams();
  const categorySlug = searchParams.get('category') || '';
  const categoryTitle = categorySlug ? formatCategorySlug(categorySlug) : '';

  return (
    <div className="container mx-auto px-4 py-8 md:py-12 flex flex-col md:flex-row gap-8">
      <Helmet>
        <title>{categoryTitle ? `${categoryTitle} - Tin tức` : 'Tin tức & Sự kiện'} - {siteInfo.name}</title>
        <meta name="description" content={`Cập nhật tin tức mới nhất về thi công khoan cọc nhồi, ép cừ, chống lún nhà và các dự án tiêu biểu của ${siteInfo.name}.`} />
        <link rel="canonical" href={`${siteInfo.baseUrl || "https://khoancocnhoivietnam.vn"}/tin-tuc`} />
      </Helmet>

      <div className="w-full md:w-3/4 min-w-0">
        <nav className="text-sm text-gray-500 mb-6 flex flex-wrap items-center gap-x-2 gap-y-1">
          <a href="/" className="hover:text-primary whitespace-nowrap">Trang chủ</a>
          <span>/</span>
          <Link to="/tin-tuc" className="hover:text-primary whitespace-nowrap">Tin tức &amp; Sự kiện</Link>
          {categoryTitle && (
            <>
              <span>/</span>
              <span className="text-gray-800 font-medium">{categoryTitle}</span>
            </>
          )}
        </nav>

        <div className="bg-white p-6 md:p-8 rounded-lg shadow-sm border">
          <h1 className="text-2xl md:text-3xl font-bold text-primary mb-8 pb-2 border-b-2 border-accent inline-block">
            {categoryTitle ? categoryTitle : 'Tin tức & Sự kiện'}
          </h1>

          <NewsGrid categorySlug={categorySlug || undefined} />
        </div>
      </div>
      
      <div className="w-full md:w-1/4 md:shrink-0">
        <Sidebar />
      </div>
    </div>
  );
}

